module.exports = __webpack_public_path__ + "img/logo-header.d51b4f36.png";